/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class, _descriptor, _descriptor2, _ConsultationFrequencyEditionForm;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { service } from "@ember/service";
import ForcBaseComponent, { ForcBaseArgs } from "core/components/forc/abstract/base-component";
import ConsultationFrequency from "core/models/consultation/consultation-frequency";
import MedicalActFrequencyChangedJournalEvent from "core/models/medical-act-frequency-changed-journal-event";
import ConfigurationService, { Configuration } from "core/services/configuration";
import SemeiaSessionService from "core/services/session";
import validateSometimes from "core/validators/sometimes";
import { Changeset, EmberChangeset } from "ember-changeset";
import lookupValidator from "ember-changeset-validations";
import { validatePresence } from "ember-changeset-validations/validators";
import { BufferedChangeset } from "validated-changeset";

// Follow the pattern described [here](https://github.com/poteto/ember-changeset/issues/551#issuecomment-728115650).
class ConsultationFrequenciesChangeset extends EmberChangeset {
  constructor(...args) {
    super(...args);
    /**
     * Optional argument that can be given to filter which consultation-frequencies to show.
     */
    _defineProperty(this, "displayedConsultationFrequencies", void 0);
    _defineProperty(this, "validations", {
      frequency: validateSometimes([validatePresence({
        presence: true,
        description: "La fréquence"
      })], function () {
        /* eslint-disable-next-line */
        return this.get("enabled");
      })
    });
  }
  get consultationFrequencies() {
    if (this._consultationFrequencies) return this._consultationFrequencies;

    // TODO: how can we redifine the type of getter `data` in the class?
    let consultationFrequenciesToDisplay = this.data.consultationFrequencies;

    // Filters the consultation-frequencies to display.
    // This is used on MentalWise to display either "physical" consultation or "psychiatrist" consultation.
    const frequencyToDisplay = this.displayedConsultationFrequencies;
    if (frequencyToDisplay) {
      consultationFrequenciesToDisplay = consultationFrequenciesToDisplay.filter(consultationFrequency => {
        for (const displayedConsultationFrequency of frequencyToDisplay) {
          if (displayedConsultationFrequency.id == consultationFrequency.id) {
            return true;
          }
        }
        return false;
      });
    }
    this._consultationFrequencies = consultationFrequenciesToDisplay.map(consultationFrequency => Changeset(consultationFrequency, lookupValidator(this.validations), this.validations));
    return this._consultationFrequencies;
  }
  get isDirty() {
    return this.consultationFrequencies.some(changeset => changeset.isDirty);
  }
  get isPristine() {
    return this.consultationFrequencies.some(changeset => changeset.isPristine);
  }
  get isValid() {
    return this.consultationFrequencies.some(changeset => changeset.isValid);
  }
  get isInvalid() {
    return this.consultationFrequencies.some(changeset => changeset.isInvalid);
  }
  async save() {
    if (!this.isDirty) return;
    this._consultationFrequencies.forEach(changeset => changeset.save());
    return super.save();
  }
}
class MedicalActsChangeset extends EmberChangeset {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "validations", {
      frequency: validateSometimes([validatePresence({
        presence: true,
        description: "La fréquence"
      })], function () {
        /* eslint-disable-next-line */
        return this.get("enabled");
      })
    });
  }
  get medicalActFrequencies() {
    if (this._medicalActFrequencies) return this._medicalActFrequencies;
    this._medicalActFrequencies = this.data.medicalActFrequencies.map(medicalActFrequency => {
      return Changeset(medicalActFrequency, lookupValidator(this.validations), this.validations);
    });
    return this._medicalActFrequencies;
  }
  get isDirty() {
    return this.medicalActFrequencies.some(changeset => changeset.isDirty);
  }
  async save() {
    if (!this.isDirty) return;
    this.source = "wise"; //update the source if the record is changed from Wise
    this._medicalActFrequencies.forEach(changeset => changeset.save());
    return super.save();
  }
}
let ConsultationFrequencyEditionForm = (_class = (_ConsultationFrequencyEditionForm = class ConsultationFrequencyEditionForm extends ForcBaseComponent {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "configuration", _descriptor, this);
    _initializerDefineProperty(this, "session", _descriptor2, this);
    _defineProperty(this, "selectableFrequencies", ConsultationFrequency.validFrequencies);
  }
  get title() {
    return this.args.title || "Plan de suivi des consultations & examens";
  }
  get lastMedicalActFrequencyJe() {
    return this.patient.medicalActFrequencyChangedJournalEvent;
  }
  get consultationsChangeset() {
    if (this._consultationsChangeset) return this._consultationsChangeset;

    // Extend Changeset class: https://github.com/poteto/ember-changeset#extending-the-base-ember-changeset-class
    this._consultationsChangeset = Changeset(this.configuration.configurationForPatient(Configuration.Consultation, this.patient), () => true, {}, {
      changeset: ConsultationFrequenciesChangeset
    });
    this._consultationsChangeset.displayedConsultationFrequencies = this.args.consultationFrequencies;
    return this._consultationsChangeset;
  }
  get medicalActsChangeset() {
    if (!this.lastMedicalActFrequencyJe) return;
    if (this._medicalActsChangeset) return this._medicalActsChangeset;

    // Extend Changeset class: https://github.com/poteto/ember-changeset#extending-the-base-ember-changeset-class
    this._medicalActsChangeset = Changeset(this.lastMedicalActFrequencyJe, () => true, {}, {
      changeset: MedicalActsChangeset
    });
    return this._medicalActsChangeset;
  }
  get isDirty() {
    return !this.medicalActsChangeset ? this.consultationsChangeset.isDirty : this.consultationsChangeset.isDirty || this.medicalActsChangeset.isDirty;
  }
  async save() {
    if (!this.medicalActsChangeset) {
      return await this.consultationsChangeset.save();
    }
    await Promise.all([this.consultationsChangeset.save(), this.medicalActsChangeset.save()]);
  }
}, _defineProperty(_ConsultationFrequencyEditionForm, "fullComponentId", "consultation-frequency/edition-form"), _ConsultationFrequencyEditionForm), _descriptor = _applyDecoratedDescriptor(_class.prototype, "configuration", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { ConsultationFrequencyEditionForm as default };